export default __webpack_public_path__ + "static/media/utensils.02d440c3.jpg";